import { Injectable } from '@angular/core';
import { Api, User } from '../'

@Injectable()
export class Master {
  list: any;

  constructor(public api:Api, public user:User) { 

  }

  company(params?: any) {
    return this.api.get('index.php/marketing/master/company', params);
  }
  
  department(params?: any) {
    return this.api.get('index.php/marketing/master/departmen', params);
  }

  sbu(params?: any) {
    return this.api.get('index.php/marketing/master/sbu', params);
  }

  branch(params?: any) {
    return this.api.get('index.php/marketing/master/branch', params);
  }

  rate(params?: any) {
    return this.api.get('index.php/marketing/master/rate', params);
  }

  stage(params?: any) {
    return this.api.get('index.php/marketing/master/stage', params);
  }

  state(params?: any) {
    return this.api.get('index.php/marketing/master/state', params);
  }

  getAbout(params?: any) {
    return this.api.get('index.php/marketing/master/about', params);
  }

  status(params?: any){
    return this.api.get('index.php/marketing/master/status', params);
  }
  
  getDisclaimer(params?: any) {
    return this.api.get('index.php/marketing/master/disclaimer', params);
  }

  filterStage(params?: any) {
    return this.api.get('index.php/marketing/master/filterStage', params);
  }

  getCompanyWinner(params?: any){
    return this.api.get("index.php/marketing/master/company_winner", params);
  }
  postCompanyWinner(params?: any){
    if(params.id == '' || params.id == undefined){
      params.created_by = this.user.data.employee_id;
    }else{
      params.updated_by = this.user.data.employee_id;
    }
    return this.api.post("index.php/marketing/master/company_winner", params);
  }

  getCurrency(params?: any){
    return this.api.get('index.php/marketing/master/currency', params);
  }

  getTenderType(params? : any){
    return this.api.get('index.php/marketing/master/tenderType', params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/marketing/master/master.ts